import { Injectable } from '@angular/core';
import {MdDialog, MdDialogConfig} from '@angular/material';
import {ErrorDialogComponent} from '../../components/error-dialog/error-dialog.component';

@Injectable()
export class ErrorService {
  constructor(public dialog: MdDialog) { }

  openDialog(error: Response): void {
    this.dialog.open(
      ErrorDialogComponent, <MdDialogConfig> {data: {message: this.parseError(error)}}
    )
  }

  parseError(error: Response): string {
    return JSON.parse(error['_body']).name[0];
  }
}



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/utilities/services/error/error.service.ts